import React from 'react';
import PropTypes from 'prop-types';
import { LuCheck, LuLock } from 'react-icons/lu';

// One numbered step of the PIF check: 1 choose the PIF, 2 upload the Proposal,
// 3 compare. A locked step shows why instead of its content, so the order of
// the work is visible without hiding what comes next.
const STATE_CLS = {
  done:    'tw-bg-emerald-600 tw-text-white',
  current: 'tw-bg-primary-600 tw-text-white',
  locked:  'tw-bg-slate-200 tw-text-slate-500',
};

const PifCheckStep = ({ number, title, description, state, lockedReason, aside, children }) => (
  <section className="tw-border tw-border-solid tw-border-slate-200 tw-rounded-lg tw-bg-white">
    <header className="tw-flex tw-items-start tw-gap-3 tw-px-4 tw-py-3">
      <span className={`tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-w-6 tw-h-6 tw-rounded-full tw-text-xs tw-font-bold ${STATE_CLS[state]}`}
        aria-hidden="true">
        {state === 'done' ? <LuCheck size={13} /> : number}
      </span>
      <div className="tw-flex-1 tw-min-w-0">
        <h3 className={`tw-m-0 tw-text-sm tw-font-semibold ${state === 'locked' ? 'tw-text-slate-400' : 'tw-text-slate-800'}`}>
          <span className="tw-sr-only">Step {number}: </span>{title}
        </h3>
        {description && <p className="tw-m-0 tw-text-xs tw-text-slate-500">{description}</p>}
      </div>
      {aside}
    </header>
    {state === 'locked' ? (
      <p className="tw-m-0 tw-px-4 tw-pb-3 tw-pl-[52px] tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-text-slate-400">
        <LuLock size={11} /> {lockedReason}
      </p>
    ) : (
      <div className="tw-border-0 tw-border-t tw-border-solid tw-border-slate-200">{children}</div>
    )}
  </section>
);

PifCheckStep.propTypes = {
  number:       PropTypes.number.isRequired,
  title:        PropTypes.string.isRequired,
  description:  PropTypes.node,
  state:        PropTypes.oneOf(['done', 'current', 'locked']).isRequired,
  lockedReason: PropTypes.node,
  aside:        PropTypes.node,
  children:     PropTypes.node,
};

export default PifCheckStep;
